// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Screenshots_gallery__a8POx"};